module.exports = __webpack_public_path__ + "static/media/21ECLAC7.aec6b70d.jpg";